export const PLANOS_2025 = {
    ECONOMY: {
        label: 'Economy',
        mensalidade: 287.60,
        implantacao: 2200.00,
        hours: 10,
        descricao: `Combo Economy Inclui:

- PDV
    - Salão (comanda e mesa)
    - Delivery + Pedidos Agendados
    - Venda rápida (fast food)
    - Integração balança
- Cardápio Digital Sischef
    - Pedidos via QR Code
    - Link Delivery e Visualização
    - Cupons de desconto
    - Taxa de entrega por KM
    - Taxa de entrega por bairro
    - Quantidade de Lojas / Marcas: 1 (uma)
- Financeiro
    - Contas a pagar e a receber
    - Transferência entre contas
    - Adiantamentos (concedidos e recebidos)
    - Consultar financeiros
    - Baixas de contas por pessoa e período
    - Recibos
    - Resumo financeiro
    - Extrato diário
    - Até 2 usuários com controle de caixa (abertura, fechamento e turno)
    - Financeiros por data
- Notificação nas áreas de produção
    - Em impressora
    - Até 2 locais além do Caixa
- Estoque
    - Entrada e saída por pedidos de compra e venda
    - Acerto de saldo
    - Entrada e saída manual
- Integração com apps
    - Até 2 aplicativos
- Fiscal
    - Emissor fiscal de NFe e NFCe – Simples Nacional
    - Carta de correção
- CRM
    - Análise de perfil dos clientes
    - Disparo de mensagens via WhatsApp
- Analytics
    - Dashboard Vendas
    - Dashboard Em Tempo Real
- Extras:
    - Auditoria de cancelamento de pedidos e produtos
    - Cadastro do primeiro cardápio
- Um Ebook Mensal`
    },
    ENTERPRISE: {
        label: 'Enterprise',
        mensalidade: 587.60,
        implantacao: 3300.00,
        hours: 20,
        descricao: `Combo Enterprise Inclui:

- PDV
    - Salão (comanda e mesa)
    - Delivery + Pedidos Agendados
    - Venda rápida (fast food)
    - Integração com balança
    - Mapa de calor
    - SmartPOS
    - Preço de produtos por horário
    - Notificação de alteração de status via WhatsApp
        - Obs.: para enviar com número da loja deve-se utilizar a conta META com forma de pagamento cadastrada
    - TEF – integração com pagamentos em cartão no PDV
        - Obs.: Incluso 1 Terminal. Para adicionar mais terminais haverá acréscimo de R$ 99,90 na mensalidade.
- Cardápio Digital Sischef
    - Pedidos via QR Code
    - Link Delivery e Visualização
    - Cupons de desconto
    - Taxa de entrega por KM
    - Taxa de entrega por bairro
    - Pagamento online
    - Totem Auto Atendimento
    - Tablet na Mesa
    - Bot (Api Oficial Meta)
    - Quantidade de Lojas / Marcas: Até 3 (três)
- Financeiro
    - Contas a pagar e a receber
    - Transferência entre contas
    - Adiantamentos (concedidos e recebidos)
    - Consultar financeiros
    - Baixas de contas por pessoa e período
    - Recibos
    - Resumo financeiro
    - Extrato diário
    - Financeiros por data
    - Lançado - Previsto - realizado
    - Até 5 usuários com controle de caixa (abertura, fechamento e turno)
    - Financeiros recorrentes
    - Lançar crédito pré-pago
    - Limite de crédito
    - Conciliação de recebíveis em cartões
    - Conciliação bancária com IA
    - DRE
    - DFC
- Notificação nas áreas de produção
    - Em impressora
    - KDS (Kitchen Display System)
    - Até 10 locais
- Estoque
    - Entrada e saída por pedidos de compra e venda
    - Acerto de saldo
    - Entrada e saída manual
    - Precificação e simulador de CMV
    - Produção de receitas
    - Múltiplos locais de estoque
    - Composição / ficha técnica
    - CMV (Custo da Mercadoria Vendida)
    - Entrada de produtos por XML e busca automática na SEFAZ
    - Requisição de compras
- Integrações
    - Até 5 integrações com apps
    - Integração com catraca
- Fiscal
    - Emissor fiscal de NFe e NFCe – Simples Nacional ou Regime Normal
    - Carta de correção
    - Usuário para o contador
    - Acesso para contador consultar notas emitidas
    - Manifestação do destinatário
- Gerenciamento de entregas
    - Despacho de pedidos por código de barras
    - Tela de acerto com entregadores
    - Roteirização inteligente
    - App pra entregador com a rota dos pedidos
    - Localização do entregador em tempo real
- CRM
    - Análise de perfil dos clientes
    - Disparo de mensagens via WhatsApp
- Analytics
    - Dashboards de vendas
    - Dashboard em tempo real
    - Dashboard de produtos
    - Dashboard de clientes
    - Auditoria
    - Dashboard de Performance por loja
    - Dashboard de Performance da operação
    - Agente de IA (Sisa)
- Extras:
    - Auditoria de cancelamento de pedidos e produtos
    - Cadastro do primeiro cardápio
    - Um Ebook Mensal`
    },
    PREMIUM: {
        label: 'Premium',
        mensalidade: 987.80,
        implantacao: 5500.00,
        hours: 30,
        descricao: `Combo Premium Inclui:

- PDV
    - Salão (comanda e mesa)
    - Delivery + Pedidos Agendados
    - Venda rápida (fast food)
    - Integração com balança
    - Mapa de calor
    - SmartPOS
    - Preço de produtos por horário
    - Notificação de alteração de status via WhatsApp
        - Obs.: para enviar com número da loja deve-se utilizar a conta META com forma de pagamento cadastrada
    - TEF – integração com pagamentos em cartão no PDV
        - Obs.: Inclusos 3 Terminais. Para adicionar mais terminais haverá acréscimo de R$ 99,90 na mensalidade.
- Cardápio Digital Sischef
    - Pedidos via QR Code
    - Link Delivery e Visualização
    - Cupons de desconto
    - Taxa de entrega por KM
    - Taxa de entrega por bairro
    - Pagamento online
    - Totem Auto Atendimento
    - Tablet na Mesa
    - Bot (Api Oficial Meta)
    - Quantidade de Lojas / Marcas: Ilimitado
- Financeiro
    - Contas a pagar e a receber
    - Transferência entre contas
    - Adiantamentos (concedidos e recebidos)
    - Consultar financeiros
    - Baixas de contas por pessoa e período
    - Recibos
    - Resumo financeiro
    - Extrato diário
    - Usuários ilimitados para controle de caixa (abertura, fechamento e turno)
    - Financeiros por data
    - Financeiros recorrentes
    - Lançar crédito pré-pago
    - Limite de crédito
    - Conciliação de recebíveis em cartões
    - Conciliação bancária com IA
    - DRE
    - DFC
- Notificação nas áreas de produção
    - Em impressora
    - KDS (Kitchen Display System)
    - Locais ilimitados
- Estoque
    - Entrada e saída por pedidos de compra e venda
    - Acerto de saldo
    - Entrada e saída manual
    - Produção de receitas
    - Múltiplos locais de estoque
    - Composição / ficha técnica
    - CMV
    - Entrada de produtos por XML e busca automática na SEFAZ
    - Requisição de compras
- Integrações
    - Integrações com apps ilimitadas
    - Integração com catraca
- Fiscal
    - Emissor fiscal de NFe e NFCe – Simples Nacional ou Regime Normal
    - Carta de correção
    - Usuário para o contador
    - Acesso para contador consultar notas emitidas
    - Manifestação do destinatário
    - SPED
- Gerenciamento de entregas
    - Despacho de pedidos por código de barras
    - Tela de acerto com entregadores
    - Roteirização inteligente
    - App pra entregador com a rota dos pedidos
    - Localização do entregador em tempo real
- CRM
    - Análise de perfil dos clientes
    - Disparo de mensagens via WhatsApp
- Analytics
    - Dashboards de vendas
    - Dashboard em tempo real
    - Dashboard de produtos
    - Dashboard de clientes
    - Auditoria
    - Dashboard de Performance por loja
    - Dashboard de Performance da operação
    - Agente de IA (Sisa)
- Extras:
- Auditoria de cancelamento de pedidos e produtos
- Cadastro do primeiro cardápio
- Consultor Executivo
- API para consulta de dados (limitado a 5 endpoints)
- Um Ebook Mensal`
    }
};
